( function Misc( $ ) {

    // Setup transition images.
    ( function transitionImages() {

        const $transition_img = $( document.querySelectorAll( '[data-transition-img]' ) );

        if( ! $transition_img.length ) {
            return;
        }

        adjustMargins();

        $(window).on( 'resize', adjustMargins );


        /**
         * Adjust margins.
         */
        function adjustMargins( $image ) {

            $transition_img.each( function( index, element ) {

                const $image = $( this );
                const height = $image[0].offsetHeight;
                const margin = ( height / 2.25 ) * -1;
                const $this_section = $( $image[0].closest( '[data-transition-img-section]' ) );
                const $next_section = $( $this_section[0].nextElementSibling );

                // Add the margin to the next section
                $next_section.css( 'margin-top', margin );

            } );


            


        }

    } )();
    


} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/misc.js